export const openWelcomeHelpScoutMessage = () => {
    if (window.Beacon) {
        window.Beacon('show-message', '4351f6ee-699a-4f33-ac92-ebf6cd1a3263', {
            force: true,
        });
    }
};
